
(function () {
  var STORAGE_KEY = 'ph_attribution';
  var EXPIRY_DAYS = 90;

  var memoryFallback = null; // used if localStorage is unavailable

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data._expires || Date.now() > data._expires) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return memoryFallback;
    }
  }

  function writeStore(data) {
    data._expires = Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      memoryFallback = data; // Safari private mode etc. — survives the session only
    }
  }

  function getParam(name) {
    try {
      var match = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
      return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    } catch (e) {
      return '';
    }
  }

  function isExternalReferrer(ref) {
    if (!ref) return false;
    try {
      return new URL(ref).hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  var PARAMS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function captureCurrent() {
    var current = {};
    var hasSignal = false;
    for (var i = 0; i < PARAMS.length; i++) {
      var v = getParam(PARAMS[i]);
      current[PARAMS[i]] = v;
      if (v) hasSignal = true;
    }
    current.referrer = isExternalReferrer(document.referrer) ? document.referrer : '';
    current.landing_page = window.location.href.split('#')[0];
    current.touched_at = new Date().toISOString();
    // A "touch" worth recording = any click ID / UTM, or an external referrer
    current._hasSignal = hasSignal || !!current.referrer;
    return current;
  }

  function apply(prefix, target, current) {
    for (var i = 0; i < PARAMS.length; i++) {
      target[prefix + PARAMS[i]] = current[PARAMS[i]] || '';
    }
    target[prefix + 'referrer'] = current.referrer || '';
    target[prefix + 'landing_page'] = current.landing_page || '';
  }

  function init() {
    var stored = readStore() || {};
    var current = captureCurrent();

    // First touch: set once, never overwritten
    if (!stored.first_touch_at) {
      stored.first_touch_at = current.touched_at;
      apply('first_', stored, current);
      // First page view always counts as the first touch, signal or not,
      // so direct first visits still record a landing page + timestamp.
    }

    // Last touch: only overwrite when this visit carries a new signal,
    // so in-site navigation doesn't wipe the stored ad click.
    if (current._hasSignal) {
      stored.last_touch_at = current.touched_at;
      apply('last_', stored, current);
    }

    writeStore(stored);
  }

  window.PH_getAttribution = function () {
    var data = readStore();
    if (!data) return {};
    var out = {};
    for (var key in data) {
      if (data.hasOwnProperty(key) && key.charAt(0) !== '_') out[key] = data[key];
    }
    return out;
  };

  init();
})();
